import { CoreMessage } from "ai";
import { z } from "zod";
import { coreAssistantMessageSchema } from "./core-assistant-message";
import { coreToolMessageSchema } from "./core-tool-message";
import { coreUserMessageSchema } from "./core-user-message";

export const coreMessageSchema = z.union([
  coreUserMessageSchema,
  coreAssistantMessageSchema,
  coreToolMessageSchema,
]) satisfies z.ZodType<CoreMessage>;

export const redoCoreMessageSchema = coreMessageSchema.and(
  z.object({ id: z.string() }),
);

export type RedoCoreMessageType = z.infer<typeof redoCoreMessageSchema>;
